<div>
	<app-setup-wizard-breadcrumbs></app-setup-wizard-breadcrumbs>
</div>
<div>
	@switch (state()) {
		@case (SetupWizardState.EDIT_STEPS_ACCOUNT) {
			<app-setup-wizard-client-editor></app-setup-wizard-client-editor>
		}
		@case (SetupWizardState.EDIT_STEPS_USERS) {
			<app-setup-wizard-user-editor></app-setup-wizard-user-editor>
		}
		@case (SetupWizardState.EDIT_STEPS_LOCATIONS) {
			<app-setup-wizard-location-editor></app-setup-wizard-location-editor>
		}
		@case (SetupWizardState.EDIT_STEPS_COURSES) {
			<app-setup-wizard-course-editor></app-setup-wizard-course-editor>
		}
		@case (SetupWizardState.EDIT_STEPS_SECTIONS) {
			<app-setup-wizard-section-editor></app-setup-wizard-section-editor>
		}
		@case (SetupWizardState.EDIT_STEPS_UNITS) {
			<app-setup-wizard-unit-editor></app-setup-wizard-unit-editor>
		}
		@case (SetupWizardState.EDIT_STEPS_LESSONS) {
			<app-setup-wizard-lesson-editor></app-setup-wizard-lesson-editor>
		}
		@case (SetupWizardState.EDIT_STEPS_ACTIVITIES) {
			<app-setup-wizard-activity-editor></app-setup-wizard-activity-editor>
		}
		@case (SetupWizardState.EDIT_STEPS_CONTENTS) {
			<app-setup-wizard-content-editor></app-setup-wizard-content-editor>
		}
		@default {
			<nz-spin nzSimple nzSize="large"></nz-spin>
		}
	}
</div>
